import { SharedLanguageService } from '@language';
import { ExtendedProfileField } from '@stylehaven/components';
import { TranslateOrDefault } from '../../helpers';

export const GetProfileFieldLabel = (translate: SharedLanguageService, profileField: ExtendedProfileField): string => {
    return TranslateOrDefault(
        translate,
        `overrides.${profileField.FieldDefinition.DottedKey}`,
        profileField.DisplayLabel
    );
};

export const GetProfileChildFieldLabels = (
    translate: SharedLanguageService,
    profileField: ExtendedProfileField
): Map<string, string> => {
    const translationsMap = new Map<string, string>();
    profileField.FieldDefinition.Children?.forEach(child => {
        const translation: string = TranslateOrDefault(translate, `overrides.${child.DottedKey}`, child.Label);
        translationsMap.set(child.Key, translation);
    });
    return translationsMap;
};
